export const apiLinks = () => {
    return {
        env: 'production',
        url: 'https://api.credicorp-register.ng/api/v1/',
        url2: 'https://api.credicorp-register.ng/api/v2/',
        awsKey: 'production/',
        applicationLink: 'https://apply.credicorp-register.ng/apply'
    };
}